import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  checkIfDemoUserExist,
  demoLogin,
  forgotPassword,
  loginUser,
  resetPassword,
} from "../../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { APP_CONST } from "../../../config/const";

import PhoneInput from "react-phone-input-2";
import { Toaster } from "../../../utils/toaster";
import { parsePhoneNumber } from "libphonenumber-js";
import BackArrow from "../../../assets/svg/back-arrow.svg";
import { useTranslation } from "react-i18next";

const LoginModal = ({ show, handleClose, handleModalShow }) => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [mobileNumber, setMobileNumber] = useState("");
  const [changeModalContent, setChangeModalContent] = useState(true);
  const [otp, setOtpValue] = useState("");
  const [password, setPassword] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isDemoUserExist, setIsDemoUserExist] = useState(false);
  const appDetails = useSelector((state) => state.app?.appDetails);
  const [email, setEmail] = useState({ email: "" });
  const isEmailOtpRequired = appDetails?.IS_EMAIL === 1;

  const { t } = useTranslation();

  useEffect(() => {
    checkDemoUser();
  }, []);

  const checkDemoUser = async () => {
    const response = await checkIfDemoUserExist();
    if (response && response?.data?.error === false) {
      setIsDemoUserExist(response?.data?.data?.hasDemoUsers === true);
    }
  };
  const validateData = () => {
    const { username, password } = formData;
    const newErrors = {};
    if (!username || username === "") {
      newErrors.username = t("username_cannot_be_empty");
    }
    if (!password || password === "") {
      newErrors.password = t("password_cannot_be_empty");
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errorData = validateData();
    if (Object.keys(errorData).length > 0) {
      setErrors(errorData);
    } else {
      let loginData = { ...formData };
      // handleClose();
      dispatch(loginUser(loginData));
    }
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
  };

  const handleSubmitForgotPass = async (e) => {
    e.preventDefault();
    let payload = {};

    if (
      (!email?.email || email?.email == "") &&
      (!mobileNumber || mobileNumber === "")
    ) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        isEmailOtpRequired
          ? t("please_enter_email")
          : t("please_enter_mobile_number")
      );
    }

    if (isEmailOtpRequired) {
      payload.email = email?.email;
    } else {
      const phoneNumber = parsePhoneNumber("+" + mobileNumber);
      payload.phone = phoneNumber.nationalNumber;
      payload.countryCode = phoneNumber.countryCallingCode;
    }

    forgotPassword(payload)
      .then((res) => {
        if (res.data.error === false) {
          Toaster(APP_CONST.TOAST_TYPE.SUCCESS, t("OTP_sent"));
          setIsOtpSent(true);
        }
      })
      .catch((err) => {
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
      });
  };

  const handleSubmitResetPass = () => {
    setIsVerifying(true);

    if (otp == "" || password == "") {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, t("all_fields_are_mandatory"));
    } else {
      const payload = {
        otp,
        password,
      };

      resetPassword(payload)
        .then((res) => {
          Toaster(APP_CONST.TOAST_TYPE.SUCCESS, t("password_reset_success"));
          // navigate("/sign-in");
          // handleClose();
          // handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
          setChangeModalContent((prev) => !prev);
        })
        .catch((err) => {
          Toaster(
            APP_CONST.TOAST_TYPE.ERROR,
            err.response.data.message || t("request_failed")
          );
          setIsVerifying(false);
        });
    }
  };

  const handleDemoLogin = () => {
    dispatch(demoLogin());
  };

  return (
    <Modal
      show={show}
      id="loginModal"
      className={"steps-canvas lgn-reg-modal login"}
      onHide={() => {
        console.log("working");
      }}
      centered
      placement={"end"}
    >
      <Modal.Header
        closeButton
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
        closeVariant="white"
      ></Modal.Header>
      <Modal.Body>
        {changeModalContent ? (
          <div
            className={
              !changeModalContent ? `login-section` : `login-section active`
            }
          >
            <Modal.Title>{t("login")}</Modal.Title>
            <div className="welcome">{t("welcome_to_madhav365")}</div>
            <div className="form-steps">
              <Form>
                <Form.Group
                  className="position-relative"
                  controlId="formBasicName"
                >
                  <Form.Control
                    type="text"
                    placeholder={t("username *")}
                    name="username"
                    onChange={handleChange}
                    isInvalid={!!errors.username}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.username}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                  className="position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder={t("password *")}
                    name="password"
                    onChange={handleChange}
                    isInvalid={!!errors.password}
                  />
                  <span
                    className="icon"
                    onClick={() => setShowPassword((s) => !s)}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </span>
                  <Form.Control.Feedback type="invalid">
                    {errors?.password}
                  </Form.Control.Feedback>
                </Form.Group>
                <div className="frgt-pwd">
                  <a
                    onClick={() => {
                      // handleClose();
                      // handleModalShow(APP_CONST.AUTH_MODAL.FORGOTO_PASSWORD);
                      setChangeModalContent((prev) => !prev);
                    }}
                  >
                    {t("forgot_password")}
                  </a>
                </div>
                <Button variant="primary" type="submit" onClick={handleSubmit}>
                  {t("login")}
                </Button>
              </Form>

              <div className="register-back">
                <span>{t("still_no_account")}</span>
                <a
                  href="#"
                  onClick={() => {
                    handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
                    handleClose(APP_CONST.AUTH_MODAL.LOGIN);
                  }}
                >
                  {t("register")}
                </a>
              </div>

              {isDemoUserExist && (
                <>
                  {/* <div className="mt-4 mb-1 demo-text">
                    Need Demo? Just Click the button below.
                  </div> */}
                  {/* <div className=" ">
                    <div
                      className="mt-1 btn btn-primary demologin"
                      onClick={handleDemoLogin}
                      style={{ padding: "10px" }}
                    >
                      Demo Login
                    </div>
                  </div> */}
                </>
              )}
            </div>
          </div>
        ) : (
          <div
            className={
              changeModalContent
                ? `login-section`
                : `login-section ForgotPasswordSection`
            }
          >
            <div className="Login-rightPart">
              <Modal.Title>{t("password_recovery")}</Modal.Title>
              <div className="welcome">{t("reset_password_content")}</div>
              <div className="form-steps">
                <Form>
                  {!isEmailOtpRequired && (
                    <Form.Group
                      className="mb-4 position-relative"
                      controlId="formBasicPassword"
                    >
                      <PhoneInput
                        country={"in"}
                        countryCodeEditable={false}
                        inputProps={{
                          name: "phone",
                        }}
                        // onlyCountries={["in"]}
                        inputStyle={{
                          width: "100%",
                        }}
                        onChange={(phone) => {
                          setMobileNumber(phone);
                        }}
                      />
                    </Form.Group>
                  )}
                  {isEmailOtpRequired && (
                    <Form.Group
                      className="mb-3 position-relative"
                      controlId="formBasicPassword"
                    >
                      <Form.Control
                        type="email"
                        placeholder={t("enter_email *")}
                        value={email.email}
                        onChange={(e) => setEmail({ email: e.target.value })}
                      />
                    </Form.Group>
                  )}
                  <Button
                    variant="primary mb-4"
                    type="submit"
                    onClick={handleSubmitForgotPass}
                  >
                    {t("get_OTP")}
                  </Button>

                  <Form.Group className="mb-4 position-relative" controlId="">
                    <Form.Control
                      type="text"
                      placeholder={t("enter_OTP *")}
                      onChange={(e) => setOtpValue(e.target.value)}
                      autoComplete="off"
                    />
                  </Form.Group>
                  <Form.Group className="mb-4 position-relative" controlId="">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder={t("enter_new_password")}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="new-password"
                    />
                    <span
                      className="icon"
                      onClick={() => setShowPassword((s) => !s)}
                    >
                      {showPassword ? <FiEyeOff /> : <FiEye />}
                    </span>
                  </Form.Group>

                  <div className="sbmt-back">
                    <a
                      href="#"
                      className="back-btn"
                      onClick={() => setChangeModalContent((prev) => !prev)}
                    >
                      <img src={BackArrow} alt="back" />
                    </a>
                    <Button
                      variant="primary"
                      onClick={handleSubmitResetPass}
                      disabled={!isOtpSent}
                    >
                      {!isVerifying ? t("submit") : t("submitting")}
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
export default LoginModal;
